import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Always send cookies for cross-origin admin calls
const client = axios.create({ baseURL: API, withCredentials: true });
client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined" && !window.location.pathname.startsWith("/admin/login")) {
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export const authMe = () => client.get("/auth/me").then((r) => r.data);
export const authLogout = () => client.post("/auth/logout", {}).then((r) => r.data);
export const exchangeGoogleSession = (session_id) =>
  client.post("/auth/session", { session_id }).then((r) => r.data);

export const adminFetch = {
  analytics: (start, end) => {
    const params = {};
    if (start) params.start_date = start;
    if (end) params.end_date = end;
    return client.get("/admin/analytics", { params }).then((r) => r.data);
  },
  newsletter: () => client.get("/admin/newsletter").then((r) => r.data),
  bookings: () => client.get("/admin/bookings").then((r) => r.data),
};

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong.";
};
